/* eslint-disable no-magic-numbers */

import Bugsnag from "@bugsnag/js";
import { AxiosError } from "axios";

const IGNORE_ERRORS = [
  400,
  401,
  403,
  404,
  410,
];

const IGNORE_CODES = [
  "ERR_CANCELED",
  "ERR_CANCELLED",
  "ERR_NETWORK",
  "ECONNABORTED",
];

export const debugLoadingGifs = (error: AxiosError): void => {
  const status = error?.response?.status;
  const code = error?.code;

  if (status && IGNORE_ERRORS.indexOf(status) >= 0) {
    return;
  }

  if (code && IGNORE_CODES.indexOf(code) >= 0) {
    return;
  }

  console.error("Error loading gifs.", error);

  if (code !== "NEVER") {
    return;
  }

  Bugsnag.notify(
    new Error("Error loading gif error"),
    event => {
      event.context = "LOADING_GIFS_ERROR";
      event.addMetadata("Error", {
        pageUrl: window.location.href,
        // @ts-ignore
        message: error?.message,
        // @ts-ignore
        status,
        // @ts-ignore
        code,
        // @ts-ignore
        responseData: JSON.stringify(error?.response?.data)
      });
    }
  );
};
